import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Doors from "@/pages/Doors";
import Welcome from "@/pages/Welcome";
import Register from "@/pages/Register";
import Reveal from "@/pages/Reveal";
import Gallery from "@/pages/Gallery";
import Projector from "@/pages/Projector";
import GrandFinale from "@/pages/GrandFinale";
import DanceFloor from "@/pages/DanceFloor";
import Admin from "@/pages/Admin";
import Memories from "@/pages/Memories";
import Director from "@/pages/Director";
import Poster from "@/pages/Poster";
import Scan from "@/pages/Scan";
import Kiosk from "@/pages/Kiosk";
import SharePage from "@/pages/SharePage";

// Static-host safe gate: "https://domain/?share=<id>" renders the share page
// from the root URL, which exists on every server (no SPA fallback needed).
function RootGate() {
  const hasShare = new URLSearchParams(window.location.search).get("share");
  return hasShare ? <SharePage /> : <Doors />;
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          {/* Until 25 Aug 2026 7:30 PM IST, "/" shows the closed Royal Doors landing. */}
          <Route path="/" element={<RootGate />} />
          <Route path="/home" element={<Doors />} />
          <Route path="/welcome" element={<Welcome />} />
          <Route path="/register" element={<Register />} />
          <Route path="/reveal/:id" element={<Reveal />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/projector" element={<Projector />} />
          <Route path="/dance" element={<DanceFloor />} />
          <Route path="/finale" element={<GrandFinale />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/memories" element={<Memories />} />
          <Route path="/director" element={<Director />} />
          <Route path="/poster/:id" element={<Poster />} />
          <Route path="/scan" element={<Scan />} />
          <Route path="/kiosk" element={<Kiosk />} />
          <Route path="/share/:id" element={<SharePage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
